// src/components/FormFields/OptionGroup.tsx
import type React from "react"
import { Box, Text, CheckboxGroup, Checkbox, VStack, Grid } from "@chakra-ui/react"
import { useController, Control } from "react-hook-form"
import { BoxTitle } from "../BoxTitle"

interface OptionGroupProps {
  name: string
  label: string
  options: string[]
  control: Control<any>
  fillColor?: string
}

export const OptionGroup: React.FC<OptionGroupProps> = ({ name, label, options, control, fillColor = "#117BAA" }) => {
  const { field } = useController({
    name,
    control,
    defaultValue: [],
  })

  const handleCheckboxChange = (value: string[]) => {
    field.onChange(value)
  }

  return (
    <BoxTitle title={label}>
        <Box p={3} border={"1px solid #ccc"} rounded={'2xl'}>
            <CheckboxGroup value={field.value || []} onChange={handleCheckboxChange}>
              <Box w="100%">
                <Grid templateColumns="repeat(2, 1fr)" gap={2}>
                  {options.map((option) => (
                  <Checkbox
                    key={option}
                    value={option}
                    sx={{
                    '.chakra-checkbox__control': {
                      borderRadius: 'full',
                      borderWidth: '1px',
                      borderColor: '#A0AEC0',
                      _checked: {
                      bg: fillColor,
                      borderColor: fillColor,
                      color: 'white',
                      _hover: {
                        bg: fillColor,
                        borderColor: fillColor,
                      },
                      },
                      _focus: {
                      boxShadow: `0 0 0 3px ${fillColor}40`,
                      },
                    },
                    '.chakra-checkbox__label': {
                      display: 'flex',
                      alignItems: 'center',
                    },
                    }}
                    w="100%"
                    alignItems="center"
                  >
                    {option}
                  </Checkbox>
                  ))}
                </Grid>
              </Box>
            </CheckboxGroup>
        </Box>
    </BoxTitle>
  )
}